// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1794":"cc5252a0","1819":"cc5252a0","4015":"cc5252a0","7351":"cc5252a0","7723":"cc5252a0"}[chunkId] + ".chunk.css";
};